"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.PresetCameraConstraints = exports.FacingMode = exports.DisplaySurface = void 0;
var FacingMode = exports.FacingMode = /*#__PURE__*/function (FacingMode) {
  FacingMode["user"] = "user";
  FacingMode["environment"] = "environment";
  return FacingMode;
}({}); // can be used later on when we add constraints in create display track
var DisplaySurface = exports.DisplaySurface = /*#__PURE__*/function (DisplaySurface) {
  DisplaySurface["browser"] = "browser";
  DisplaySurface["monitor"] = "monitor";
  DisplaySurface["window"] = "window";
  return DisplaySurface;
}({});
var PresetCameraConstraints = exports.PresetCameraConstraints = {
  '1080p': {
    frameRate: 30,
    width: 1920,
    height: 1080
  },
  '720p': {
    frameRate: 30,
    width: 1280,
    height: 720
  },
  '480p': {
    frameRate: 30,
    width: 640,
    height: 480
  },
  '360p': {
    frameRate: 30,
    width: 640,
    height: 360
  },
  '240p': {
    frameRate: 30,
    width: 320,
    height: 240
  },
  '180p': {
    frameRate: 30,
    width: 320,
    height: 180
  },
  '120p': {
    frameRate: 30,
    width: 160,
    height: 120
  }
};
//# sourceMappingURL=constants.js.map
